import React, { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useSelector } from "react-redux";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Switch } from "@progress/kendo-react-inputs";
import { useNavigate, useLocation } from "react-router";
import { NotificationManager } from "src/util/notify";
import { useDispatch } from "react-redux";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import ApiUrls from "../../helper/api-urls";
import ApiHelper from "../../helper/api-helper";
import APP_ROUTES from "../../helper/app-routes";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { clinicService } from "../../services/clinicService";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import ErrorHelper from "../../helper/error-helper";
import { TEMPLATE_TYPE } from "../../actions";

const AddDocumentTemplate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const regionData = useSelector((state) => state.getRegion);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [validationError, setValidationError] = useState(false);
  const [documentTemplate, setDocumentTemplate] = useState([]);

  const [fields, setFields] = useState({
    regionName: "",
    templateTypeId: "",
    templateName: "",
    isFileTemplate: true,
    htmlFileName: "",
    isDefault: true,
  });

  useEffect(() => {
    getTemplateType();
  }, [fields.regionName]);

  const getTemplateType = () => {
    ApiHelper.getRequest(ApiUrls.DOCUMENT_TEMPLATE_TYPE + state?.fields?.regionName?.id)
      .then((result) => {
        setDocumentTemplate(result.resultData);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const addClinic = async () => {
    setLoading(true);
    await fileDocumentService
      .addFileDocumentTemplate(fields)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Add File Document Template successfully");
        setFields({
          regionName: "",
          templateTypeId: "",
          templateName: "",
          isFileTemplate: true,
          htmlFileName: "",
          isDefault: true,})
          setValidationError(false);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const updateClinic = async () => {
    setLoading(true);
    await fileDocumentService
      .updateFileDocumentTemplate(fields, state)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(
          "Update File Document Template successfully"
        );
        navigate(APP_ROUTES.CLINIC);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!fields.templateTypeId) {
      formIsValid = false;
      errors["templateTypeId"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.htmlFileName || fields.htmlFileName.trim().length === 0) {
      formIsValid = false;
      errors["htmlFileName"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.templateName || fields.templateName.trim().length === 0) {
      formIsValid = false;
      errors["templateName"] = ErrorHelper.FIELD_BLANK;
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleSubmit = (event) => {
    setValidationError(true);
    if (handleValidation()) {
      addClinic()

    }
  };

  const handleCancel = () => {
    navigate(APP_ROUTES.FILE_DOCUMENT_TEMPLATE);
  };

  return (
    <>
      <div className="client-accept notenetic-container placeholder-size">
        <h4 h4 className="address-title text-grey mb-5 ">
          <span className="f-24">Add File Document Template</span>
        </h4>
        <div className="row">
          <div className="mb-3 col-lg-4 col-md-6 col-12 edit-Service-popup">
            <DropDownKendoRct
              filterable={true}
              label="Region"
              onChange={handleChange}
              data={regionData}
              value={fields.regionName}
              textField="regionName"
              name="regionName"
              dataItemKey="id"
              suggest={true}

            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12 edit-Service-popup">
            <DropDownKendoRct
              validityStyles={validationError}
              filterable={true}
              label="Template Type"
              onChange={handleChange}
              data={documentTemplate}
              value={fields.templateTypeId}
              textField="name"
              name="templateTypeId"
              dataItemKey="id"
              suggest={true}
              required={true}
              error={fields.templateTypeId === "" && errors.templateTypeId}

            />
          </div>
          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <InputKendoRct
              validityStyles={validationError}
              value={fields.templateName}
              onChange={handleChange}
              name="templateName"
              label="Template Name"
              className="form-control"
              placeholder="Template name"
              error={fields.templateName === "" && errors.templateName}
              required={true}
            />
          </div>
          <div className="">
            <div className="mb-3 col-lg-4 col-md-6 col-12">
              <Checkbox
                onChange={handleChange}
                label={"File Template"}
                name="isClientNotSubscriber"
                value={fields.isFileTemplate}
                disabled={true}
              />
            </div>
            <div className="mb-3 col-lg-4 col-md-6 col-12 default-switch">
              <Switch
                label=""
                onChange={handleChange}
                checked={fields.isDefault}
                name="isDefault"
                onLabel={"Default"}
                offLabel={""}
              />
              <span className="ml-2 mt-4">Default</span>
            </div>
          </div>

          <div className="mb-3 col-lg-4 col-md-6 col-12">
            <InputKendoRct
              validityStyles={validationError}
              value={fields.htmlFileName}
              onChange={handleChange}
              name="htmlFileName"
              label="Html File Name"
              className="form-control"
              placeholder="Template name"
              error={fields.htmlFileName === "" && errors.htmlFileName}
              required={true}
            />
          </div>
        </div>
      </div>
      {loading == true && <Loader />}

      <div className="d-flex my-4 ">
        <button className="green-btn btn-primary border-0 mr-3 btn-space" onClick={handleSubmit}>
          {/* {state ? "Update" : "Add"} */}
          Add
        </button>

        <button className="btn grey-secondary btn-space " onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </>
  );
};

export default AddDocumentTemplate;
